import { groq, PortableTextBlock } from "next-sanity";

export type ImageType = {
	id: string;
	alt: string;
	url: string;
	metadata: {
		lqip: string;
		dimensions: {
			aspectRatio: number;
			height: number;
			width: number;
		};
	};
};

export type VideoType = {
	title: string;
	vimeo: string;
	thumbnail: ImageType;
};
export type ProjectType = {
	id: string;
	slug: { current: string };
	title: string;
	description?: PortableTextBlock[];
	thumbnail?: ImageType & {
		_type: "thumbnail";
	};
	content: Array<
		| ({ _type: "projectImage" } & ImageType)
		| ({ _type: "film" } & VideoType)
	>;
	isWebsite: boolean;
	website?: {
		href: string;
		title: string;
	};
	hasPressRelease: boolean;
	pressReleaseLink: string;
	pressRelease: {
		name: string;
		extension: string;
		url: string;
		id: string;
	};
};

export const projectQuery = groq`
	"id": _id,
    orderRank,
    slug { current },
  	thumbnail-> { 
        "id": _id,
        alt, 
        ...{ ...img.asset->{ url, metadata { lqip, dimensions { aspectRatio, height, width } } } },
    }, 
    title,
    description,
    isWebsite,
    website{ href, title },
    content[]{
        _type,

		_type == "film" => {
			title,
			vimeo,
			thumbnail->{ 
              "id": _id,
              alt, 
              ...{ ...img.asset->{ url, metadata { lqip, dimensions { aspectRatio, height, width } } } },
            } 
        },

		_type == "projectImage" => {
              "id": _id,
              alt, 
              ...{ ...img.asset->{ url, metadata { lqip, dimensions { aspectRatio, height, width } } } },
        } 
	},
	hasPressRelease,
	pressReleaseLink,
	pressRelease {
		...asset->{
		"name": originalFilename,
		extension,
		url,
		"id": _id,
		}
	}
`;

export const allProjectsQuery = groq`*[_type == "project" && !(_id in path("drafts.**"))] | order(orderRank) {
   ${projectQuery}
}`;

export const projectBySlug = groq`
*[_type == "project" && slug.current == $slug ][0] {
 ${projectQuery}
}`;
